import React, { useContext } from 'react';
import ColorsContext from './ColorsContext';

export default function PcpnTable(props) {
  const { regionData, monyr, spiList, areaType } = props;
  const { levelColors } = useContext(ColorsContext);
  
  const droughtRegions = [
    "Western",
    "Connecticut River",
    "Central",
    "Northeast",
    "Southeast",
    "Cape Cod",
    "Islands"
  ];

  const basins = [
    "Blackstone",
    "Boston Harbor",
    "Buzzards Bay",
    "Cape Cod",
    "Charles",
    "Chicopee",
    "Connecticut",
    "Deerfield",
    "Farmington",
    "French",
    "Housatonic",
    "Hudson",
    "Ipswich",
    "Islands",
    "Merrimack",
    "Millers",
    "Narragansett Bay",
    "Nashua",
    "North Coastal",
    "Parker",
    "Quinebaug",
    "Shawsheen",
    "South Coastal",
    "SuAsCo",
    "Taunton",
    "Ten Mile",
    "Westfield"
  ];

  const counties = [
    "Barnstable",
    "Berkshire",
    "Bristol",
    "Dukes",
    "Essex",
    "Franklin",
    "Hampden",
    "Hampshire",
    "Middlesex",
    "Nantucket",
    "Norfolk",
    "Plymouth",
    "Suffolk",
    "Worcester"
  ];

  var droughtAreas;
  switch (areaType) {
    case 'region':
      droughtAreas = droughtRegions;
      break;
    case 'basin':
       droughtAreas = basins;
      break;
    case 'county':
      droughtAreas = counties;
      break;
    default:
      console.log(`Bad areaType selection - ${areaType}`);
      droughtAreas = droughtRegions;
  }

  return (
    <>
    <table className="pcpnTable-container">
      <caption>
        {monyr} {monyr.search(",") < 0 ? "Monthly" : "30-Day"} Precipitation Summary
      </caption>
      <thead>
        <tr>
          <th scope="col">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
          <th scope="col">Number of <br />sites reporting</th>
          <th scope="col">Historical <br />average (inches)</th>
          <th scope="col" abbr="Average">{monyr} <br />average (inches)</th>
          <th scope="col" abbr="Departure">Departure from <br />historical (inches)</th>
          <th scope="col" abbr="Percent">Percent of <br />historical</th>
        </tr>
      </thead>
      <tbody>
        {droughtAreas.map((rd, i) => (
          <tr key={i}>
            <th scope="row">{droughtAreas[i].replace("Connecticut River","CTRV")}</th>
            <td>{regionData[rd][spiList[0]].count}</td>
            <td>{regionData[rd][spiList[0]].hist.toFixed(2).replace("-999.00","-")}</td>
            <td>{regionData[rd][spiList[0]].pcpn.toFixed(2).replace("-999.00","-")}</td>
            <td>{regionData[rd][spiList[0]].pcpn !== -999 ? (regionData[rd][spiList[0]].pcpn - regionData[rd][spiList[0]].hist).toFixed(2) : "-"}</td>
            <td>{regionData[rd][spiList[0]].pcpn !== -999 ? Math.round((regionData[rd][spiList[0]].pcpn / regionData[rd][spiList[0]].hist)*100)+"%" : "-"}</td>
          </tr>
        ))}
      </tbody>
    </table>

    <table className="pcpnTable-container">
      <caption>
        Standardized Precipitation Index Percentiles
      </caption>      
      <thead>
        <tr>
          <td colSpan="5">
            <table className="tableLegend-container">
              <tbody>
                <tr>
                  <td className="tableLegend-heading" colSpan="5">Shading indicates index severity level:</td>
                </tr>
                <tr>
                  <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[0]}}>Level 0</td>
                  <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[1]}}>Level 1</td>
                  <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[2]}}>Level 2</td>
                  <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[3]}}>Level 3</td>
                  <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[4], "color":"white"}}>Level 4</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </thead>

      <tbody>
        <tr>
          <th id="reg1">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
          <th id="0m">{spiList[0]}</th>
          <th id="1m">{spiList[1]}</th>
          <th id="2m">{spiList[2]}</th>
          <th id="3m">{spiList[3]}</th>
        </tr>
        {droughtAreas.map((rd, i) => (
          <tr key={i}>
            <th id={"reg1"+i} headers="reg1">{rd.replace("Connecticut River","CTRV")}</th>
            {spiList.slice(0,4).map((mon, j) => (
              <td 
                headers={"reg1"+i + " " + j+"m"} 
                key={mon} 
                style={{
                  backgroundColor:regionData[rd][mon] ? levelColors[regionData[rd][mon].level] : "white", 
                  color:regionData[rd][mon].level !== 4 ? "black" : "white"
                }}
              >
                {regionData[rd][mon].spi !== -999 ? regionData[rd][mon].pctl.toFixed(0) : "-"}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
      
      <tbody>
        <tr>
          <th id="reg2">Region</th>
          <th id="4m">{spiList[4]}</th>
          <th id="5m">{spiList[5]}</th>
          <th id="6m">{spiList[6]}</th>
          <th id="7m">{spiList[7]}</th>
        </tr>
        {droughtAreas.map((rd, i) => (
          <tr key={i}>
            <th id={"reg2"+i} headers="reg2">{rd.replace("Connecticut River","CTRV")}</th>
            {spiList.slice(4,8).map((mon, j) => (
              <td 
                headers={"reg2"+i + " " + (j+4)+"m"} 
                key={mon} 
                style={{
                  backgroundColor:regionData[rd][mon] ? levelColors[regionData[rd][mon].level] : "white",
                  color:regionData[rd][mon].level !== 4 ? "black" : "white"
                }}
              >
                {regionData[rd][mon].spi !== -999 ? regionData[rd][mon].pctl.toFixed(0) : "-"}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    </>
  );
}